export class MaintenanceError extends Error {

}